// extracted by mini-css-extract-plugin
export var documentation = "_hk-1";
export var menu = "_hk-0";